// extracted by mini-css-extract-plugin
export default {"mainBtn":"Button_mainBtn__7pQ4C"};